<template>
    <div class="home">
        <Header 
          v-if="$route.name!='Aiwenda'&&$route.name!='AiImgwenda'&&$route.name!='AiToolwenda'&&$route.name!='AiHome'&&$route.name!='Ai'"
          :username="username" 
          :isLogIn="isLogIn"
          @login="login"
          @logout="logOut"
          @apply-trial="applyTrial"
          @change-password="changePassword"
        ></Header>
        <router-view 
          :key="$route.fullPath" 
          @goto-trial="goToTrial"
        ></router-view>
        <!-- <Footer ></Footer> -->
        <Login ref="login" @login-success="loginSuccess" @change-password="changePassword"></Login>
        <ApplyTrial ref="applyTrial"></ApplyTrial>
        <ChangePassword ref="changePassword"></ChangePassword>
    </div>
</template>
<script>
import Login from '@/components/Login.vue'
import ApplyTrial from '@/components/ApplyTrial.vue'
import ChangePassword from '@/components/ChangePassword.vue'
import Header from '@/components/Header'
import Api from '@/api'
import { getUserToken, getUserName, removeUserInfo } from '@/utils/user'
// import Footer from '@/components/Footer'
export default {
    name: 'home',
    components: {
        Header,
        Login,
        ApplyTrial,
        ChangePassword
        // Footer
    },
    data() {
        return {
            username: '',
            isLogIn: false
        }
    },
    created() {
        this.username = getUserName()
        this.isLogIn = !!getUserToken()
    },
    methods: {
        login() {
            this.$refs.login.showDialog()
        },
        loginSuccess(data) {
            this.username = data.nickname
            this.isLogIn = true
        },
        applyTrial() {
            if(!getUserToken()) {
                this.login()
            } else {
                Api.checkApplyStatus().then(res => {
                    if (res && res.code === 200) {
                        if (!res.data) {
                            this.$refs.applyTrial.showApplyForm()
                        } else if(res.data.status === 1) {
                            this.$refs.applyTrial.showPassDialog()
                        } else if(res.data.status === 0 || res.data.status === -1) {
                            this.$refs.applyTrial.showAuditDialog()
                        }
                    }
                })
            }
        },
        goToTrial() {
            if(!getUserToken()) {
                this.login()
            } else {
                Api.checkApplyStatus().then(res => {
                    if (res && res.code === 200) {
                        if (!res.data) {
                            this.$refs.applyTrial.showApplyForm()
                        } else if(res.data.status === 1) {
                            this.$router.push({
                                path: "/safeContent"
                            })
                        } else if(res.data.status === 0 || res.data.status === -1) {
                            this.$refs.applyTrial.showAuditDialog()
                        }
                    }
                })
            }
        },
        changePassword() {
            this.$refs.changePassword.showDialog()
        },
        logOut() {
            this.isLogIn = false
            this.username = ''
            removeUserInfo()
        }
    }
}
</script>
<style>
.ivu-modal-wrap, .ivu-modal-mask {
    z-index: 2100 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/Home.vue